<template>
  <div class="design-text">
  <div class="design-side">
    <div
      v-for="(textDesignFromList, index) in this.uStore.userDesigns[
        store.currentEditingProps.productId
      ].designs[store.currentEditingProps.variantId].imgVariants[store.currentEditingProps.imageToPreview]
        .texts"
      :key="index"
      class="elements-container"
    >
        <div :class="store.currentEditingProps.currentPreview == 'text' && store.currentEditingProps.currentPreviewIndex == index ? 'element-div ele-div-active' : 'element-div'">

          <div class="element-line-1">
              <div class="ele-title-line">
                <span class="ele-title">
                  <span class="ele-title-txt">Enter Text</span>
                </span>
                <span class="remove-container" @click.stop="delText(index)">
                  <img class="remove-img" src="../../../public/Icons-DeleteBlackIcon.png"/>
                  <span class="remove-title">Remove</span>
                </span>
              </div>
              <span class="ele-input-container">
                <input class="ele-input" v-if="store.allFontsFiles.value[textDesignFromList.fontID].isRtl == undefined || store.allFontsFiles.value[textDesignFromList.fontID].isRtl == null || store.allFontsFiles.value[textDesignFromList.fontID].isRtl == false" placeholder="Write Your Text.." type="text"
                v-model="
               uStore.userDesigns[store.currentEditingProps.productId].designs[
                  store.currentEditingProps.variantId
                ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
                ].text
                "
               @input="filterInput($event,index)"
               />
               

              <input v-else class="ele-input hebrew" placeholder="הכנס טקסט..." type="text"
                v-model="
               uStore.userDesigns[store.currentEditingProps.productId].designs[
                  store.currentEditingProps.variantId
                ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
                ].text
                "
                @input="filterInput($event,index)"
              />
                <span class="change-size-container">
                  <span @click="increaseSize(index)">+</span>
                  <span>
                    <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.846 7.83H2.59L1.806 10H0.462L3.99 0.298H5.46L8.974 10H7.63L6.846 7.83ZM6.482 6.794L4.718 1.866L2.954 6.794H6.482ZM14.8126 8.295H11.4686L10.8526 10H9.79659L12.5686 2.377H13.7236L16.4846 10H15.4286L14.8126 8.295ZM14.5266 7.481L13.1406 3.609L11.7546 7.481H14.5266Z" fill="#2D2D2D"/>
                    </svg>
                  </span>
                  <span @click="decreaseSize(index)">-</span>
                </span>
              </span>
          </div>
          <div class="element-line-2">
            <div class="form-outline propLine">
              <label class="lableInOpenLine">Font</label>
              <!-- {{ store.getAllTextFontFiles() }} -->
              <vue-select
                class="form-control openLineInput font-selected"
                :close-on-select="true"
                :min="1"
                :options="store.getAllTextFontFiles()"
                label-by="fontName"
                value-by="fontID"
                searchable
                :model-value="
                 uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                    index
                  ].fontID
                "
                @update:modelValue="
                  (value) => {
                    if (value !== null && value !== undefined) {
                     uStore.userDesigns[store.currentEditingProps.productId].designs[
                        store.currentEditingProps.variantId
                      ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                        index
                      ].fontID = value;
                      updateFont(index);
                    }
                  }
                "
              >
                <template #label="{ selected }">
                  <template v-if="selected">
                    <div class="font-txt-preview">
                      <span class="txt-preview-comp">
                        <div v-html="selected.svgContent" style=" overflow: hidden; display: block;"></div>
                        
                    </span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="font-txt-preview">
                      <span class="txt-preview-comp">
                        <div v-html="selected.svgContent" style="overflow: hidden; display: block;"></div>
                    </span>
                    </div>
                  </template>
                </template>
                <template #dropdown-item="{ option }">
                  <div class="font-txt-preview">
                      <span class="txt-preview-comp">                    
                        <div v-html="option.svgContent" style="overflow: hidden; display: block;
                         /* padding:60px 0; */
                         "></div>
                    </span>
                  </div>
                </template>
              </vue-select>
            </div>
            <div v-if="store.currentEditingProps.productType == 'ColorSticker'" class="form-outline propLine">
              <label class="lableInOpenLine" style="padding-left: 11px;">Color</label>
              <div class="font-layers-colors-container">
                <template v-for="(layerColorID, colorIndex) in uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
                  ].layersColors" :key="colorIndex">
                      <SelectColor 
              :model-value="uStore.userDesigns[store.currentEditingProps.productId].designs[
                  store.currentEditingProps.variantId
              ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
              ].layersColors[colorIndex]"
              @update:modelValue="(value) => {
                  if (value !== null && value !== undefined) { 
                    uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                      index
                  ].layersColors[colorIndex] = value;
        }
    }"
    @loadText="(colorID) => loadTextColor(colorID,index)"
/>



                    <!-- v-model="uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                      index
                  ].layersColors[colorIndex]" -->
                </template>
              </div>                      
            </div>

            <div class="form-outline propLine">
              <label class="lableInOpenLine" style="display: flex; align-items: flex-end;"
                ><span>Arc </span>&nbsp;
                <span style="font-size: 12px;">{{
                 uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
                  ].textArc
                }}°</span>&nbsp;
              </label>
              <div class="form-control" style="display: flex; gap: 5px;">                        
                <span class="reset-arc" title="Reset Arc"
                    @click="resetArc(index)">                          
                <img
                  :src="store.baseIconsURL + '//Icons-ResetArcIcon.png'"
                  style="height: 7px;"
                />
                </span>
                <MDBRange
                  class="form-range"
                  :min="-180"
                  :max="180"
                  v-model="
                   uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                    ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                    index
                    ].textArc
                  "
                  @change="changeArc(index)"
                />
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
      <span class="btn-add-element" title="Add New Text" @click="addTextSVGToDesign()">
        + Add New Text
      </span>
  </div>
</div>
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import { userStore } from "@/stores/userStore";
import VueSelect from "vue-next-select";
import SelectColor from "../SelectColor.vue";
import {
MDBRange,
} from "mdb-vue-ui-kit";
import {ref} from "vue";
import {
    nextTick
} from "vue-demi";


export default {
  components: {
      SelectColor,
      MDBRange,
      VueSelect,
  },
  setup() {
      const store = designerStore();
      const uStore = userStore();
      const textRef = ref(null);

      return {
          store,
          uStore,
          textRef,
          nextTick
      };
  },
  data() {
    return {
     
    }
  },
  props: {
      changeStyleByRef: {
          type: Function,
          required: true
      },
      increaseTextSize: {
          type: Function,
          required: true
      },
      decreaseTextSize: {
          type: Function,
          required: true
      }
      // changeArc: {
      //     type: Function,
      //     required: true
      // },
      // resetArc: {
      //     type: Function,
      //     required: true
      // },
  },
  // async mounted() {
   
  // props: ["textPreview", "imageToPreview", "productId", "variantId", "currentPreviewIndex", "currentPreview", "dpi"],
  // },
  methods: {
    async loadTextColor(colorID, index) {
        var textObj = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        this.store.currentEditingProps.variantId
        ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
            index
        ];
         var arc = textObj.textArc;

        var svgTag = this.store.loadText(arc, textObj.text, 20,  colorID, textObj.fontID).svg;

          // this.store.allFontsFiles.value[textObj.fontID].relativeFontPath, 
          //   textObj.text, 
          //   colorID
        // );
        // .then(({ svgTag, width, height }) => {
        //   console.log('Generated SVG:', svgTag);
        //   console.log('Width:', width, 'Height:', height);
        //   this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        // this.store.currentEditingProps.variantId
        // ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //     index
        // ].svgContent = svgTag;
        // })
        // .catch(err => {
        //   console.error('Error loading text:', err);
        // });
        this.uStore.userDesigns[this.store.currentEditingProps.productId]
                    .designs[this.store.currentEditingProps.variantId
        ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
            index
        ].svgContent = svgTag;
    },
    increaseSize(index) {
          this.store.currentEditingProps.currentPreviewIndex = index;
          this.increaseTextSize(index);
      },
      decreaseSize(index) {
          this.store.currentEditingProps.currentPreviewIndex = index;
          this.decreaseTextSize(index);
      },
    async addTextSVGToDesign() {
      this.store.currentEditingProps.textPreview = {
          imageName: this.store.currentEditingProps.imageToPreview,
          text: "",
          fontID: this.store.getAllFontsFiles()[0].fontID,
          layersColors: this.store.currentEditingProps.productType != 'WoodEngrave' && this.store.currentEditingProps.productType != 'GlassEngrave' ? this.store.getAllSVGColors().slice(0, 1).map(m => m.colorID) : this.store.blackForWoodAndGlassId,
          //colorID: this.store.blackColorIdDst,
          textArc: 0,
          location: { x: 0, y: 0, arc: 0 },
      };
          this.store.addTextSVGToDesign(
          this.store.currentEditingProps.productId,
          this.store.currentEditingProps.variantId,
          this.store.currentEditingProps.textPreview
          );
      this.store.currentEditingProps.currentPreviewIndex =
          this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
          .imgVariants[this.store.currentEditingProps.imageToPreview].texts.length - 1;
      this.store.currentEditingProps.currentPreview = "text";
      await this.changeStyleByRef('text');
    },
    delAllTexts() {
      this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        this.store.currentEditingProps.variantId
      ].imgVariants[this.store.currentEditingProps.imageToPreview].texts = [];
      this.store.currentEditingProps.currentPreviewIndex = -1;
    },
    openElement(type, index) {
      this.store.currentEditingProps.currentPreviewIndex = this.store.currentEditingProps.currentPreviewIndex == index ? -1 : index;
      this.store.currentEditingProps.currentPreview = type;
      this.store.currentEditingProps.changeSelectedArt = false;
      this.store.currentEditingProps.changeSelectedMonogram = false;
      // this.newMonogram = this.newMonogram == null ? null : 0;
      this.store.currentEditingProps.newArt = (this.store.currentEditingProps.newArt == true || this.store.currentEditingProps.newArt == false) ? false : null;
      this.store.currentEditingProps.newMonogram = (this.store.currentEditingProps.newMonogram == true || this.store.currentEditingProps.newMonogram == false) ? false : null;
    },
     async changeArc(index) {
      this.store.currentEditingProps.currentPreviewIndex = index;
      // var originalSvgString = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
      //   this.store.currentEditingProps.variantId
      // ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
      //   this.store.currentEditingProps.currentPreviewIndex
      // ].svgContent;
      var textObj = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        this.store.currentEditingProps.variantId
      ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        this.store.currentEditingProps.currentPreviewIndex
      ];
      var arc = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                    this.store.currentEditingProps.variantId
                    ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
                    this.store.currentEditingProps.currentPreviewIndex
                    ].textArc;
      // const result = this.store.arcSvgPaths(originalSvgString, arc, 120);
      const result = this.store.loadText(arc, textObj.text, 20, textObj.layersColors[0], textObj.fontID);
      this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        this.store.currentEditingProps.variantId
        ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
            this.store.currentEditingProps.currentPreviewIndex
        ].svgContent = result.svg;
        // this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        // this.store.currentEditingProps.variantId
        // ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //     this.store.currentEditingProps.currentPreviewIndex
        // ].dragTransform.width = result.width;
        // this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        // this.store.currentEditingProps.variantId
        // ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //     this.store.currentEditingProps.currentPreviewIndex
        // ].dragTransform.height = result.height;
        
    this.updateTextSVGLocation(index);

      await nextTick();
      //נסיון לקבל את גודל הטקסט בתוך הSVG
      if(this.textRef != null) {
        const startPos = this.textRef.value.getStartPositionOfChar(0);
        const endPos = this.textRef.value.getEndPositionOfChar(textObj.text.length - 1);
        this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                      this.store.currentEditingProps.variantId
                      ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
                      this.store.currentEditingProps.currentPreviewIndex
                      ].dragTransform.x = (startPos.x + endPos.x) / 2;
        this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                      this.store.currentEditingProps.variantId
                      ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
                      this.store.currentEditingProps.currentPreviewIndex
                      ].dragTransform.y = (startPos.y + endPos.y) / 2;
      }
     },
     async resetArc(index) {
      this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
                    this.store.currentEditingProps.variantId
                    ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
                    this.store.currentEditingProps.currentPreviewIndex
                    ].textArc = 0;
      await this.changeArc(index);
     },
    filterInput(event, index) {
      // let font=Object.keys(this.store.allFontsFiles.value[ this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
      //     this.store.currentEditingProps.variantId
      //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
      //     index
      //   ].fontID].sizes["1"].DictCharacters);
      //   const characterString = font.join('');
              

      // const regex = new RegExp(`[^${characterString}]`, 'g');
      // const input = event.target.value;
      // if (regex.test(input)) {
      //   event.target.value = input.replace(regex, '');
      
      // }

      // else
      // if (this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
      //       this.store.currentEditingProps.variantId
      //     ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
      //       index
      //     ].fontID.isRtl == false)


      
      // var fontID = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
      //       this.store.currentEditingProps.variantId
      //     ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
      //       index
      //     ].fontID;
      // if(this.store.allFontsFiles.value[fontID].isRtl === true) {
      //     this.reverseText(index);
      // }

    this.updateTextSVGLocation(index);

  },
async reverseText(index) {
  let text = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
    this.store.currentEditingProps.variantId
  ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[index].text;
  if (text.length > 0) {
    let lastChar = text[text.length - 1];
    text = lastChar + text.slice(0, -1);
  }
  this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
    this.store.currentEditingProps.variantId
  ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[index].text = text;
},
    async updateTextSVGLocation(index) {
      // this.store.movInd++;
      var textObj =
        this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
          .imgVariants[this.store.currentEditingProps.imageToPreview].texts[index];
        this.store.updateTextSVGLocation(
          this.store.currentEditingProps.productId,
          this.store.currentEditingProps.variantId,
          this.store.currentEditingProps.imageToPreview,
          index,
          textObj.text,
          textObj.dragLocation.x,
          textObj.dragLocation.y,
          textObj.textArc,
          textObj.fontID
        );

        // this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        //   this.store.currentEditingProps.variantId
        //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //   index].dragTransform.width = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].texts[index].dragSize.w;

        //   this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        //   this.store.currentEditingProps.variantId
        //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //   index].dragTransform.height = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId].imgVariants[this.store.currentEditingProps.imageToPreview].texts[index].dragSize.h;
         
          await this.changeStyleByRef('text');
    },
    updateTextLayersColors(textObjFromStore) {
      //בשינוי פונט - בודק כמה שכבות של צבעים שמורות בסטור
      //בודק כמה שכבות צריך בשביל הפונט החדש לפי האות שהוקלדה
      //מחסיר או מוסיף צבע לרשימת הצבעים בסטור
      //כל פעם יכול להיות שתוקלד אות עם צבע אחד יותר
      var currentLayers = textObjFromStore.layersColors.length;
      var maxLettersLayers =
      Math.max(...Object.values(textObjFromStore.text).map(m => this.store.allFonts.value[textObjFromStore.fontID].sizes[textObjFromStore.fontSizeID]
            .DictCharacters[m].dstfile.layerCount));
      console.log('currentLayers = ', currentLayers);
      console.log('maxLettersLayers = ', maxLettersLayers);
     
      // this.store.allFonts.value[textObjFromStore.fontID].sizes[textObjFromStore.fontSizeID]
      //       .DictCharacters[textObjFromStore.text[textObjFromStore.text.length-1]].dstfile.layerCount;

      if(currentLayers < maxLettersLayers) { //אם חסרות שכבות בסטור - מוסיף את מספר השכבות הזה
        this.addColorLayer(textObjFromStore, maxLettersLayers - currentLayers);
      } else if (currentLayers > maxLettersLayers) { //אם יש יותר מידי שכבות בסטור - מוחק מה שצריך
        this.removeColorLayer(textObjFromStore, currentLayers - maxLettersLayers);
      }
    },
    delText(index) {
      this.store.delText(
        this.store.currentEditingProps.productId,
        this.store.currentEditingProps.variantId,
        this.store.currentEditingProps.imageToPreview,
        index
      );
      this.store.currentEditingProps.currentPreviewIndex = -1;
      // this.currentPreview = "";
    },
    addColorLayer(textObjFromStore, sumMissLayers) {
      var listColorsToAdd = this.store.getAllSVGColors().slice(textObjFromStore.layersColors.length - 1, sumMissLayers).map(m => m.colorID);
      listColorsToAdd.forEach(colorID => {
        textObjFromStore.layersColors.push(colorID);
      });
    },
    removeColorLayer(textObjFromStore, sumLayersToRemove) {
      textObjFromStore.layersColors.splice(textObjFromStore.layersColors.length - sumLayersToRemove, sumLayersToRemove);
    },
    updateFont(currentPreviewIndex) {
      this.updateTextSVGLocation(currentPreviewIndex);
    },
  }
};
</script>

<style>

.form-outline .form-control{
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 12px;
  border-radius: 1px;
      height: 32px;
}
.selected-color{
    border: 1px solid #D9D9D9;
    align-items: center;
    height: 32px;
}
.select-color-container{
  /* padding:0 14px !important; */
  border-radius: 1px;
}
/* .form-outline {
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 12px;
} */
.arrow-downward.active {
  border: none;
  width: 14px;
  height: 14px;
  background-size: contain;
  background-position: center;
  background-image: url("https://embgift.myshopify.com/cdn/shop/t/5/assets//Icons-CloseIconBlack.png");
}
.arrow-downward{
  background-size: contain;
  background-position: center;
  width: 14px;
  height: 14px;
  border: none;
  background-image: url("https://embgift.myshopify.com/cdn/shop/t/5/assets//Icons-OpenIconBlack.png");
}
</style>
<style scoped>

.vue-dropdown{
  width: 100% !important;
  padding: 0 !important;
  border-radius:4px !important;
  max-height:300px !important;
  max-height: 300px !important;
}

.vue-dropdown-item{
  padding: 0px !important;
/* padding: 5px 20px !important; */
height:30px !important;
}
.vue-dropdown-item {
    padding: 0 !important;
    margin: 0;
}


.openLine {
  display: grid;
}
.elements-container {
margin-bottom: 8px;
}
.element-line-2 {
  display: flex;
}


input.ele-search-input {
  border: 1px solid #D9D9D9;
  border-radius: 4px 0px 0px 4px;
  padding: 3px 6px;
  font-size: 12px;
}
.item-line {
  display: flex;
  justify-content: space-between;
}
span.floatRight {
  display: flex;
  gap: 22px;
  margin-right: 6px;
  margin-bottom: 3px;
}

.ele-input{
  border: 1px solid #D9D9D9;
  height: 32px;
  font-family: "Roboto",sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    letter-spacing: 0%;
    border-radius: 4px;
}
.ele-input::placeholder{
color: rgba(186, 186, 186, 1);
}
.element-div{
color: rgba(45, 45, 45, 1);
}
.hebrew {
direction: rtl; /* יישור הטקסט מימין לשמאל */
text-align: right; /* יישור פיזי של הטקסט לצד ימין */
}
@media only screen and (max-width: 768px) {
.vue-dropdown {
  position: fixed !important;
    top: 0px !important;
    left: 0px !important;
    right: 0px !important;
    margin: auto !important;
    position: fixed !important;
    width: 80% !important;
    max-height: 80vh !important;
    height: 80vh !important;
}
}

</style>